import * as $ from 'jquery';

import {Global} from '../init-global';

import { TweenLite, TimelineLite, Sine, Power3 } from 'gsap';
const activated = [ TweenLite, TimelineLite, Power3 ];
require('jquery-debounced-and-throttled-resize/jquery.debouncedresize.js');


/* Accordion for product advice (nutrition and ingredients)
*/

export class ProductAdviceAccordion {

    protected $root:JQuery;
    protected tl:TimelineLite;
    protected isMobile: boolean;
    protected breakpoint:number = 980;


    constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
    	this.$root.on({
    		click: (e:any) => {
                let $target = $(e.currentTarget);
                if ($target.attr('aria-expanded') !== 'true') {
                    this.resetAll();
                    let $content = $target.next('.c-product-advice__content');
                    $target.attr('aria-expanded', 'true').attr('aria-disabled', 'true').addClass('is-open');
                    $content.get(0).hidden = false;

                    TweenLite.set($content, { css: { height: 0, opacity: 0 } });
                    let h = $content.children().first().outerHeight(true);
                    TweenLite.to($content, 0.3, { opacity: 1, height: h, ease: Power3.easeInOut, onComplete: () => { TweenLite.set($content, { clearProps: 'all' }); } });
                }
    		}
    	}, '.c-product-advice__heading');


        // Set starting state according to layout mode
        this.refreshViewport();

        // Watch the viewport for size changes
        $(window).on('debouncedresize', () => this.refreshViewport());
    }

    private initDesktop = () => {
        $('#heading-nutrition').attr('aria-expanded', 'true').attr('aria-disabled', 'true').addClass('is-open');
        $('#heading-nutrition').next('.c-product-advice__content').get(0).hidden = false;
        $('#heading-ingredients').attr('aria-expanded', 'false').attr('aria-disabled', 'false').removeClass('is-open');
        $('#heading-ingredients').next('.c-product-advice__content').get(0).hidden = true;
    }

    private initMobile = () => {
        $('#heading-nutrition, #heading-ingredients').attr('aria-expanded', 'false').attr('aria-disabled', 'true').removeClass('is-open');
        $('#heading-nutrition, #heading-ingredients').next('.c-product-advice__content').get(0).hidden = true;
    }

    private resetAll = () => {
    	let $active = $('.c-product-advice__heading', this.$root).filter('[aria-expanded=true]');
    	if ($active.length) {
    		$active.attr('aria-expanded', 'false').attr('aria-disabled', 'false').removeClass('is-open');
    		let $content = $active.next('.c-product-advice__content');
    		$content.get(0).hidden = true;
    	}
    }

    private refreshViewport = () => {
        let vp = Global.getViewport();
        let dspForMobile:boolean = (vp.width < this.breakpoint) ? true: false;

        if (dspForMobile != this.isMobile) {
            this.isMobile = dspForMobile;
            (this.isMobile) ? this.initMobile(): this.initDesktop();
        }
    }
}